import ConfigForm from './ConfigForm.jsx';

const ENUM_BASE_SCHEMA = [
  { key: 'render_as', label: 'Render as', kind: 'text' },
  { key: 'placeholder', label: 'Placeholder', kind: 'text' },
  { key: 'none_label', label: 'None label', kind: 'text' },
  { key: 'hide_none', label: 'Hide none', kind: 'boolean' },
];

export default function EnumConfig({ field, onConfigChange, extraSchema = [] }) {
  const schema = [...ENUM_BASE_SCHEMA, ...extraSchema];
  return <ConfigForm schema={schema} config={field.config} onConfigChange={onConfigChange} />;
}
